import { z } from "zod";

const materialUsageCorrugateDetailSchema = z.object({
	corrugateAlias: z.string().nullable().optional(),
	corrugateFlute: z.string().nullable().optional(),
	corrugateBrand: z.string().nullable().optional(),
	corrugateWidth: z.number(),
	totalConsumedCorrugate: z.number(),
	baleCount: z.number().nullable().optional(),
});

const materialUsageByMachineSchema = z.object({
	machineId: z.string().nullable().optional(),
	machineName: z.string().nullable().optional(),
	totalTapeConsumption: z.number(),
	totalGlueConsumption: z.number(),
	totalConsumedCorrugate: z.number(),
	corrugateDetails: z.array(materialUsageCorrugateDetailSchema).default([]),
});

const materialUsageOverTimeDataSchema = z.object({
	year: z.number(),
	month: z.number(),
	week: z.number(),
	day: z.number(),
	hour: z.number(),
	minute: z.number(),
	isoYear: z.number(),
	isoWeek: z.number(),
	isPartial: z.boolean().nullable().optional(),
	tapeConsumption: z.number(),
	glueConsumption: z.number(),
	corrugateConsumption: z.number(),
});

const materialUsageOverTimeSchema = z.object({
	corrugateAlias: z.string().nullable().optional(),
	corrugateFlute: z.string().nullable().optional(),
	corrugateBrand: z.string().nullable().optional(),
	corrugateWidth: z.number().optional(),
	data: z.array(materialUsageOverTimeDataSchema).default([]),
});

export const materialUsageResponseSchema = z.object({
	totalTapeConsumption: z.number(),
	totalGlueConsumption: z.number(),
	totalConsumedCorrugate: z.number(),
	isScheduleApplied: z.boolean(),
	byMachine: z.array(materialUsageByMachineSchema).default([]),
	overTime: z.array(materialUsageOverTimeSchema).default([]),
	totalBaleCount: z.number().nullable().optional(),
});

export type MaterialUsageCorrugateDetail = z.infer<typeof materialUsageCorrugateDetailSchema>;
export type MaterialUsageByMachine = z.infer<typeof materialUsageByMachineSchema>;
export type MaterialUsageOverTimeData = z.infer<typeof materialUsageOverTimeDataSchema>;
export type MaterialUsageOverTime = z.infer<typeof materialUsageOverTimeSchema>;
export type MaterialUsageResponse = z.infer<typeof materialUsageResponseSchema>;

export const DEFAULT_MATERIAL_USAGE_RESPONSE: MaterialUsageResponse = {
	totalTapeConsumption: 0,
	totalGlueConsumption: 0,
	totalConsumedCorrugate: 0,
	isScheduleApplied: false,
	byMachine: [],
	overTime: [],
	totalBaleCount: null,
};
